import { ApolloClient, createHttpLink, InMemoryCache, gql } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';

const httpLink = createHttpLink({
    uri: process.env.REACT_APP_URL_GRAPH,
});

const authLink = setContext((_, { headers }) => {
    // return the headers to the context so httpLink can read them
    return {
      headers: {
        ...headers,
        'X-API-KEY': process.env.REACT_APP_APIKEY_GRAPH,
      },
    }
});

export const client = new ApolloClient({
    link: authLink.concat(httpLink),
    cache: new InMemoryCache(),
});



export const saveDocumentsClient = async (comprobantd, curp, idmpleado, flow, ineAnverso, inereverso, selfie, selfieToine, uiid ) => {

    const MutationDocuments = gql`
        mutation DocumentClient {
            processDocument(files: {
                comprobante: "${comprobantd}", 
                curp:         "${curp}",
                idEmpleado:    ${idmpleado}, 
                enmOrigen: web,
                flow: ${flow},
                ineAnverso: "${ineAnverso}", 
                ineReverso: "${inereverso}", 
                selfie: "${selfie}", 
                selfieToIne: ${selfieToine},
                uuid: "${uiid}"}
            ) {
                code
                message
                response {
                    comprobante
                    curp
                    ineAnverso
                    ineReverso
                    selfie
                    url
                    uuid
                  }
            }
        } `;


    try {
        const response = await client.mutate({
            mutation: MutationDocuments,
            fetchPolicy:  "no-cache"
        });

        if(response.data.processDocument.code === 200){
            return responseSaves(response.data.processDocument.response)  
        }else{
            return responseSaves('error')  
        }
        
    } catch (error) {

        return responseSaves('error')  
    }


}

export const deleteDocumentClient = async (uuid, image, value) => {

    var document = "ineObverse";
    var valued   = false;

    if(image === "INEF"){
        document  = "ineObverse";
        valued    = value;
    }else if(image === "INER"){
        document  = "ineReverse";
        valued    = value;
    }else if(image === "CURP"){
        document  = "curp";
        valued    = value;
    }else if(image === "SELFIE"){
        document  = "selfie";
        valued    = value;
    }else if(image === "IMGDOC"){
        document  = "proofOfAddress";
        valued    = value;
    }else if(image === "INEFT"){
        document  = "ineObverseTemp"
        valued    = value;
    }else if(image === "INERT"){
        document  = "ineReverseTemp"
        valued    = value;
    }

    const MutationDeleteDocuments = gql`
        mutation DeleteImage {
            deleteImagesS3(input: {uuid: "${uuid}", ${document}: ${valued}}) {
            code
            message
            response
            }
        }`;

    try {
        const response = await client.mutate({
            mutation: MutationDeleteDocuments
        });

        return responseSaves(response.data.deleteImagesS3)  
        
    } catch (error) {
        return responseSaves('error')  
    }

}

export const saveDataGeneral = async (uuid, idempleado, apellidop, apellidom, ciudadNacimiento, claveElector, noIne, curp, estadoc, estadoNacimiento, fechanac, nombre, rfc, sexo) => {

    const MutationDataGeneral = fechanac === null ? gql`
        mutation MutationGeneral {
            doPersonalInformation(input: {
                apellidoMaterno:   "${apellidom}", 
                apellidoPaterno:   "${apellidop}",
                ciudadNacimiento:  "${ciudadNacimiento}",
                claveElector:      "${claveElector}",
                numeroINE:         "${noIne}", 
                curp:              "${curp}", 
                estadoCivil:        ${estadoc}, 
                estadoNacimiento:  "${estadoNacimiento}",
                nombre:            "${nombre}", 
                rfc:               "${rfc}", 
                sexo:               ${sexo},
                idEmpleado:         ${idempleado}, 
                uuid:              "${uuid}"}) {
                code
                message
            }
    }`
    :
    gql`
        mutation MutationGeneral {
            doPersonalInformation(input: {
                apellidoMaterno:   "${apellidom}", 
                apellidoPaterno:   "${apellidop}",
                ciudadNacimiento:  "${ciudadNacimiento}",
                claveElector:      "${claveElector}",
                numeroINE:         "${noIne}", 
                curp:              "${curp}", 
                estadoCivil:        ${estadoc}, 
                estadoNacimiento:  "${estadoNacimiento}",
                fechaNacimiento:   "${fechanac}", 
                nombre:            "${nombre}", 
                rfc:               "${rfc}", 
                sexo:               ${sexo},
                idEmpleado:         ${idempleado}, 
                uuid:              "${uuid}"}) {
                code
                message
            }
    }`;
        
    try {
        const response = await client.mutate({
            mutation: MutationDataGeneral
        });

        return responseSaves(response.data.doPersonalInformation)
        
    } catch (error) {
        return responseSaves('error')
    }

}

export const saveDataDomicilio = async (uuid, calle, codepostal, ciudad, colonia, estado, municipio, numeroext, numeroint, pais) => {

    const MutationDataAdress = gql`
        mutation MutationAdress {
            doAddress(input: {
                calle:        "${calle}", 
                codigoPostal: "${codepostal}", 
                ciudad: "${ciudad}", 
                colonia: "${colonia}", 
                estado: "${estado}", 
                municipio: "${municipio}", 
                numeroExterno: "${numeroext}", 
                numeroInterno: "${numeroint}", 
                pais: "${pais}", 
                uuid: "${uuid}"}) {
            code
            message
            }
        }`;
    
    try {
        const response = await client.mutate({
            mutation: MutationDataAdress,
        });

        return responseSaves(response.data.doAddress)
        
    } catch (error) {
        return responseSaves('error')
    }
}

export const saveDataContact = async (uuid, isVeriication, phoneHome, phonecell, email) => {

    const MutationDataContact = gql`
        mutation MutationContact {
            doContact(input: {flagVerification: ${isVeriication}, email: "${email}", telefonoCasa: "${phoneHome}", telefonoCelular: "${phonecell}", uuid: "${uuid}"}) {
            code
            message
            }
        } `;

    try {
        const response = await client.mutate({
            mutation: MutationDataContact,
        });

        return responseSaves(response.data.doContact)
        
    } catch (error) {
        return responseSaves('error')
    }

}

export const saveCurp  = async (curp, uuid) => {

    const MutationSaveCurp = gql`
        mutation MutationCurp {
            saveCurp(input: {curp: "${curp}", uuid: "${uuid}"}) {
                code
                message
            }
        } `;

    try {
        const response = await client.mutate({
            mutation: MutationSaveCurp,
        });

        return responseSaves(response.data.saveCurp)
        
    } catch (error) {
        return responseSaves('error')
    }
        

}

export const saveVigence = async (isvegence, uuid) => {

    const MutationSaveINEVigence = gql`
        mutation MutacionVigence {
            saveVigence(input: {uuid: "${uuid}", vigence: ${isvegence}}) {
            code
            message
            }
        }`;

    try {
        const response = await client.mutate({
            mutation: MutationSaveINEVigence,
        });

        return responseSaves(response.data.saveVigence)
        
    } catch (error) {
        return responseSaves('error')
    }
}

export const saveCommentSelfie = async (comment, status, uiid) => {

    const MutationCommentSelfie = gql`
        mutation MutacionCSelfie {
            doCommentSelfie(input: {
                comment: "${comment}", 
                status: "${status}", 
                uuid: "${uiid}"}
            ) {
            code
            message
            }
        }`;

    try {
        const response = await client.mutate({
            mutation: MutationCommentSelfie,
        });

        return responseSaves(response.data.doCommentSelfie)
        
    } catch (error) {
        return responseSaves('error')
    }

}

export const saveResultsC  = async (curp, idemploye, uiidp, flow, comment, dicflow) => {

    const MutationSaveComments = gql`
        mutation SaveComments {
            doAdvanceFlow(input: {
                businessKey: "${curp}", 
                clientUuid:  "${uiidp}", 
                comments:    "${comment}", 
                numFlow:      ${flow}, 
                target:      "${idemploye}"
                ${dicflow}
            }) {
            code
            message
            }
        }`;

    try {
        const response = await client.mutate({
            mutation: MutationSaveComments,
        });
    
        return responseSaves(response.data.SaveComments)
            
    } catch (error) {
        return responseSaves('error')
    }
}
 
const responseSaves = (resp) => {
    return resp
}